import React from 'react'
import PropTypes from 'prop-types'
import css from 'styled-jsx/css'

const styles = css`
  span {
    display: inline-block;
    vertical-align: middle;
    position: relative;
  }

  svg {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`

const getRotation = (direction) => {
  switch (direction) {
    case 'right':
      return 0
    case 'left':
      return 180
    case 'down':
      return 90
    case 'up':
      return -90
    default:
      return 0
  }
}

const ChevronIcon = ({
  width = 20,
  height = 20,
  color = 'currentColor',
  direction = 'right',
}) => (
  <span
    data-testid="span-element"
    style={{
      transform: `rotate(${getRotation(direction)}deg)`,
      width: `${width}px`,
      height: `${height}px`,
    }}
  >
    <svg
      data-testid="svg-element"
      width={width}
      height={height}
      viewBox="0 0 1792 1792"
      fill={color}
    >
      <path d="M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z" />
    </svg>
    <style jsx>{styles}</style>
  </span>
)

ChevronIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
  direction: PropTypes.oneOf([
    'up',
    'down',
    'left',
    'right',
  ]),
}

export default ChevronIcon
